'use client';

import * as DS from '@aurorasolar/ds';

import { useCurrency } from '@/hooks/useCurrency';

import { RangeInput } from './RangeInput';

type Props = {
  bill: number;
  onBillChange: (bill: number) => void;
  onZipChange: (zip: string) => void;
  zip: string;
  zipError?: string;
};

export const BILL_MAX = 800;
export const BILL_MIN = 50;
export const BILL_STEP = 10;

export const HeroInputs = ({ bill, onBillChange, onZipChange, zip, zipError }: Props) => {
  const { formatCurrency } = useCurrency();

  return (
    <DS.Flex gap={4} maxW="420px" mx="auto" pt={8} w="100%">
      <DS.Flex gap={1}>
        <DS.Flex minW={0} position="relative">
          <DS.InputPrimitive
            $size="md"
            aria-label="5-digit zip code"
            borderRadius="default"
            color="uiFormInput.filledTextColor"
            inputMode="numeric"
            maxLength={5}
            onChange={(event) => onZipChange(event.target.value.replace(/\D/g, ''))}
            pattern="\d{5}"
            placeholder="5-digit zip"
            // 16px via inline style: the [data-input-size='md'] selector outspecifies the xstyled fontSize prop
            style={{ fontSize: '16px', paddingLeft: 36 }}
            value={zip}
            w="100%"
          />
          <DS.IconLocationPin
            color="uiHelperCopy"
            left={8}
            position="absolute"
            size={4}
            top="50%"
            transform="translateY(-50%)"
            zIndex="above"
          />
        </DS.Flex>
        {zipError ? (
          <DS.Text color="uiError" role="alert" text="body12">
            {zipError}
          </DS.Text>
        ) : null}
      </DS.Flex>

      <DS.Flex gap={6}>
        <DS.Flex alignItems="baseline" flexDirection="row" justifyContent="space-between">
          <DS.Text as="label" htmlFor="electrification-bill" text="body14">
            Monthly electric bill
          </DS.Text>
          <DS.Text text="h1">{formatCurrency(bill)}</DS.Text>
        </DS.Flex>
        <RangeInput
          ariaLabel="Monthly electric bill"
          id="electrification-bill"
          max={BILL_MAX}
          min={BILL_MIN}
          onChange={onBillChange}
          step={BILL_STEP}
          value={bill}
        />
      </DS.Flex>
    </DS.Flex>
  );
};
